// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='var(--boxel-ai-icon-size, var(--boxel-icon-xs))'
    height='var(--boxel-ai-icon-size, var(--boxel-icon-xs))'
    fill='none'
    viewBox='0 0 24 24'
    ...attributes
  ><path
      fill='currentColor'
      d='M12 2v4a6 6 0 0 1 6 6h4A10 10 0 0 0 12 2m0 20v-4a6 6 0 0 1-6-6H2a10 10 0 0 0 10 10m10-10h-4a6 6 0 0 1-6 6v4a10 10 0 0 0 10-10M2 12h4a6 6 0 0 1 6-6V2A10 10 0 0 0 2 12'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'AiBw';
export default IconComponent;
